/**
 * FI_MODULES — Shared configuration for the FI Operating System navigation.
 * Used by both Layout.js (sidebar nav) and FIWorkspace.js (content routing).
 *
 * Lifecycle order: Origination → Pipeline → Eligibility → Credit → Portfolio
 *                  → Climate Risk → Carbon Desk → Reporting → Strategic
 *
 * Key principle:
 *   Deal Origination = entry into system (intake only)
 *   Pipeline         = management of deals already inside FI (standalone)
 */
import {
  LayoutDashboard, PlusCircle, Layers, CheckCircle2, Target, Activity,
  Shield, GitBranch, FileText, Globe
} from "lucide-react";

export const FI_MODULES = [
  {
    key: "dashboard", label: "Executive Dashboard", icon: LayoutDashboard,
    sections: [{ key: "dashboard", label: "Dashboard" }],
  },
  {
    key: "origination", label: "Deal Origination", icon: PlusCircle,
    sections: [
      { key: "create_deal", label: "Deal Intake" },
    ],
  },
  {
    key: "pipeline_mgmt", label: "Pipeline", icon: Layers,
    sections: [{ key: "pipeline", label: "Pipeline" }],
  },
  {
    key: "eligibility", label: "Eligibility & Screening", icon: CheckCircle2,
    sections: [
      { key: "screening",    label: "Deal Screening"    },
      { key: "eligibility",  label: "Eligibility Engine"},
      { key: "signal_score", label: "Signal Score"      },
    ],
  },
  {
    key: "credit", label: "Credit Engine", icon: Target,
    sections: [
      { key: "financing",   label: "Financial Structuring" },
      { key: "data_import", label: "Due Diligence"         },
      { key: "decision",    label: "Deal Actions"          },
      { key: "credit_memo", label: "Credit Memo"           },
    ],
  },
  {
    key: "portfolio", label: "Portfolio & Monitoring", icon: Activity,
    sections: [
      { key: "analytics",       label: "Portfolio Summary" },
      { key: "portfolio_intel", label: "Risk Intelligence" },
      { key: "monitoring",      label: "Post-Disbursement" },
    ],
  },
  {
    key: "climate_risk", label: "Climate Risk & Scenarios", icon: Shield,
    sections: [
      { key: "risk",   label: "Climate Risk"     },
      { key: "stress", label: "Scenario Analysis" },
    ],
  },
  {
    key: "carbon", label: "Carbon Desk", icon: GitBranch,
    sections: [
      { key: "carbon",   label: "Carbon Analysis" },
      { key: "vcm_desk", label: "VCM / Article 6" },
    ],
  },
  {
    key: "reporting", label: "Reporting & Disclosure", icon: FileText,
    sections: [
      { key: "regulatory", label: "Regulatory Reports"  },
      { key: "gov_config", label: "Governance Config"   },
      { key: "rbac",       label: "Audit & Permissions" },
      { key: "compliance", label: "Compliance"          },
    ],
  },
  {
    key: "strategic", label: "Strategic Layer", icon: Globe,
    sections: [
      { key: "syndication",  label: "Deal Syndication" },
      { key: "coinvestment", label: "Co-Investment"    },
      { key: "poa_desk",     label: "PoA Aggregation"  },
    ],
  },
];
